import React from 'react'
import PropTypes from 'prop-types'
import {Text, Box} from '@chakra-ui/react'

const PayeeCell = ({row}) => {
  return (
    <Box>
      <Text>{row.original.payee?.name}</Text>
      {row.original.paymentReference ? (
        <Text fontSize="sm" color="gray.500">
          Ref: {row.original.paymentReference}
        </Text>
      ) : null}
    </Box>
  )
}

PayeeCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      payee: PropTypes.shape({
        name: PropTypes.string,
      }),
      paymentReference: PropTypes.string,
    }),
  }).isRequired,
}

export default PayeeCell
